import { SessionId } from '../../commonv3/types/sessions';
import { ISODateTime } from '../../commonv3/types/dates';
import { OnlineLocation, SheLocation } from './location';
import { TokenType } from '../../commonv3/types/tokens';

export enum SessionType {
    GROUP_COACHING = 'group_coaching',
    MOKUMOKU = 'mokumoku',
    MULTICREATOR_CAREER_COACHING = 'multicreator_career_coaching',
    INITIAL_MULTICREATOR_CAREER_COACHING = 'initial_multicreator_career_coaching',
    MULTICREATOR_FINAL_REVIEW = 'multicreator_final_review',
    MULTICREATOR_INTERMEDIATE_REVIEW = 'multicreator_intermediate_review',
}

export enum SessionTemplateKey {
    ONLINE_INITIAL_GROUP_COACHING = 'online_initial_coaching',
    OFFLINE_INITIAL_GROUP_COACHING = 'offline_initial_coaching',
    ONLINE_INITIAL_GROUP_COACHING_V2_FIRST = 'online_initial_coaching_v2_first',
    OFFLINE_INITIAL_GROUP_COACHING_V2_FIRST = 'offline_initial_coaching_v2_first',
    ONLINE_INITIAL_GROUP_COACHING_V2_SECOND = 'online_initial_coaching_v2_second',
    OFFLINE_INITIAL_GROUP_COACHING_V2_SECOND = 'offline_initial_coaching_v2_second',
    ONLINE_REGULAR_GROUP_COACHING = 'online_regular_coaching',
    OFFLINE_REGULAR_GROUP_COACHING = 'offline_regular_coaching',
    OFFLINE_MOKUMOKU_DESIGN = 'offline_mokumoku_design',
    OFFLINE_MOKUMOKU_WRITING = 'offline_mokumoku_writing',
    OFFLINE_MOKUMOKU_MARKETING = 'offline_mokumoku_marketing',
}

export const AllInitialCoachingSessions = [
    SessionTemplateKey.ONLINE_INITIAL_GROUP_COACHING,
    SessionTemplateKey.OFFLINE_INITIAL_GROUP_COACHING,
    SessionTemplateKey.ONLINE_INITIAL_GROUP_COACHING_V2_FIRST,
    SessionTemplateKey.OFFLINE_INITIAL_GROUP_COACHING_V2_FIRST,
    SessionTemplateKey.ONLINE_INITIAL_GROUP_COACHING_V2_SECOND,
    SessionTemplateKey.OFFLINE_INITIAL_GROUP_COACHING_V2_SECOND,
];

export function isInitialCoachingSession(key: SessionTemplateKey) {
    return AllInitialCoachingSessions.includes(key);
}

export function isRegularCoachingSession(key: SessionTemplateKey) {
    return [
        SessionTemplateKey.ONLINE_REGULAR_GROUP_COACHING,
        SessionTemplateKey.OFFLINE_REGULAR_GROUP_COACHING,
    ].includes(key);
}

export function isFullSession(session: SessionIndexView) {
    return session.active_reservation_count >= session.capacity;
}

export type SessionIndexView = {
    id: SessionId;
    session_type: SessionType;
    title: string;
    template_name: string;
    template_key: SessionTemplateKey;
    required_token_type: TokenType;
    required_token_amount: number;
    params: SessionParameter[];
    location: SheLocation | OnlineLocation;
    starts_at: ISODateTime;
    ends_at: ISODateTime;
    active_reservation_count: number;
    capacity: number;
};

export type SessionShowView = SessionIndexView;

export enum SessionParameterKey {
    LABELS = 'labels',
    ZOOM_URL = 'zoom_url',
}

export enum SessionParameterType {
    STRING = 'StringSessionParameter',
    INTEGER = 'IntegerSessionParameter',
    TEXT = 'TextSessionParameter',
}

export type StringSessionParameter<K extends SessionParameterKey> = {
    param_type: SessionParameterType.STRING | SessionParameterType.TEXT;
    key: K;
    value: string;
};

export type IntegerSessionParameter<K extends SessionParameterKey> = {
    param_type: SessionParameterType.INTEGER;
    key: K;
    value: number;
};

export type SessionParameter =
    | StringSessionParameter<SessionParameterKey.LABELS>
    | StringSessionParameter<SessionParameterKey.ZOOM_URL>;
